import { render, staticRenderFns } from "./VideoRoomStart.vue?vue&type=template&id=0d3489d4&scoped=true&"
import script from "./VideoRoomStart.vue?vue&type=script&lang=js&"
export * from "./VideoRoomStart.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomStart.vue?vue&type=style&index=0&id=0d3489d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3489d4",
  null
  
)

export default component.exports